// Format Project Progress (from Projects Table) as Percentage

/**
 * Converts a decimal progress value to a percentage string
 * @param {number} decimal - Progress value as decimal (0-1)
 * @returns {string} - Formatted percentage (0-100)
 */
export const formatProgress = (decimal) => {
  return (decimal * 100).toFixed(0);
};
